import React from "react";
import { Row, Col } from "react-flexbox-grid";
import Masonry from "react-masonry-css";
//Scss
import "./portfolio.scss";
//Assets
import Arrow from "../../assets/portfolio/arrow.svg";
import Preview1 from "../../assets/portfolio/paani bav.jpg";
import Preview2 from "../../assets/portfolio/paani_ig.jpg";
import Preview3 from "../../assets/portfolio/design post final.jpg";
import Preview4 from "../../assets/portfolio/YESTERYEAR_front.jpg";
import Preview5 from "../../assets/portfolio/YESTERYEAR_back.jpg";
import Preview6 from "../../assets/portfolio/dietyFizz project final.jpg";
//Components
import Button from "../ui-components/button/button";
import Title from "../ui-components/title/title";
import ProjectBox from "../ui-components/projectBox/projectBox";
import ReactApp from "./react-project";
import image from "../../assets/portfolio/project.png";
import userImage from "../../assets/portfolio/user-screen.png";
import careerImage from "../../assets/portfolio/career.png";

class Portfolio extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // PORTFOLIO PROJECTS
      projects: [
        {
          id: "1",
          preview: Preview1,
          title: "Lyrical IG Post",
          tag: "illustrations",
        },
        {
          id: "2",
          preview: Preview2,
          title: "Paani-Song Cover",
          tag: "illustrations",
        },
        {
          id: "3",
          preview: Preview3,
          title: "Design Theme for Song Covers",
          tag: "illustrations",
        },
        {
          id: "4",
          preview: Preview4,
          title: "Bookmark Gift Cover-Front",
          tag: "illustrations",
        },
        {
          id: "5",
          preview: Preview5,
          title: "Bookmark Gift Cover-Back",
          tag: "illustrations",
        },
        {
          id: "6",
          preview: Preview6,
          title: "Logo- A Diet Consulting Clinic",
          tag: "branding",
        },
      ],
      // PORTFOLIO GALLERY WILL LOAD THIS AFTER FUNCTION "filterGallery" FINISH FILTERING
      filterResult: null,
      pickedFilter: "all",
      filterMenuActive: false,
      pickedFilterDropdown: "NEWEST"
    };
  }

  // FIRST LOAD
  componentDidMount() {
    this.filterGallery("all");
  }

  //FILTER PORTFOLIO FUNCTION
  filterGallery = (target) => {
    let projectsArr = [...this.state.projects];
    let result;

    if (target !== "all") {
      result = projectsArr.filter((project) => project.tag === target);
    } else {
      result = projectsArr;
    }

    this.setState({ filterResult: result, pickedFilter: target, pickedFilterDropdown: "NEWEST" });
  };

  // FILTER DROP DOWN HOVER MENU FUNCTION
  filterMenuHover = (event) => {
    if(event) {
      this.setState({ filterMenuActive: true });
    }else {
      this.setState({ filterMenuActive: false });
    }
  }

  // FILTER DROP DOWN HANDLER
  filterDropDownHandler = (filter) => {
    this.setState({ pickedFilterDropdown: filter, filterMenuActive: false });

    let projectsArr = [...this.state.filterResult];
    let result;

    if (filter === "NEWEST") {
      result = projectsArr.sort((a, b) => (a.id > b.id ? 1 : -1));
    }else if (filter === "OLDEST") {
      result = projectsArr.sort((a, b) => (a.id > b.id ? 1 : -1)).reverse();
    }

    this.setState({ filterResult: result});
  }

  // RENDER
  render() {
    // PORTFOLIO GALLERY RENDER
    let projectsRender = null;
    if (this.state.filterResult) {
      projectsRender = this.state.filterResult.map((project) => (
        <ProjectBox preview={project.preview} key={project.id} title={project.title} tag={project.tag} />
      ));
    }
    // PORTFOLIO GALLERY BREAKPOINTS
    const portfolioBreakpoints = {
      default: 3,
      1100: 3,
      700: 2,
      500: 1,
    };
    // PORTFOLIO FILTER DROPDOWN MENY RENDER
    let filterDroppDown = null;
    if(this.state.filterMenuActive) {
      filterDroppDown = (
        <div className="portfolio__filter-menu shadow">
          <p className="font12" onClick={() => this.filterDropDownHandler("NEWEST")}>
            NEWEST
          </p>
          <p className="font12" onClick={() => this.filterDropDownHandler("OLDEST")}>
            OLDEST
          </p>
        </div>
      );
    }

    return (
      <div id="portfolio">
        <div className="wrapper">
          <div className="showcase font60 weight800 padding40"> WORK SHOWCASE</div>
          <ReactApp headTo="https://random-famous-quote-generator-react.netlify.app/" headline="Random Quote App Built With React" img={image}/>
          <ReactApp headTo="https://www.figma.com/file/zL1GK78zVQZrjSkQ59J8Vz/UX-Research-VegaMos-Your-Every-Day-Mmos" headline="UX Research VegaMos" img={userImage}/>
          <ReactApp headTo="https://docs.google.com/presentation/d/e/2PACX-1vR75Ft5j9NBaWkT7dVxl13nFhboI3hoTz72ID5FE6HNm5T_DispTxK0mFAtrllCVkcMSWJA_oN_dIyb/pub?start=true&loop=false&delayms=2000"
                  headline="Designing A Framework For Better Employability On Campus"  img={careerImage}/>
          
          <h1 className="weight600 design">Design Projects</h1>
         
          <Row>
            <Col xs={12} sm={12} md={8} lg={9}>
              <div className="portfolio__nav">
                <ul>
                  <li className={this.state.pickedFilter === "all" ? "portfolio__nav-active font12" : "font12"} onClick={() => this.filterGallery("all")}>
                    ALL
                  </li>
                  <li
                    className={this.state.pickedFilter === "branding" ? "portfolio__nav-active font12" : "font12"}
                    onClick={() => this.filterGallery("branding")}
                  >
                    BRANDING
                  </li>
                  <li
                    className={this.state.pickedFilter === "illustrations" ? "portfolio__nav-active font12" : "font12"}
                    onClick={() => this.filterGallery("illustrations")}
                  >
                    ILLUSTRATIONS
                  </li>
                  
                </ul>
              </div>
            </Col>
            <Col xs={12} sm={12} md={4} lg={3}>
              <div className="portfolio__filter" onMouseEnter={() => this.filterMenuHover(true)} onMouseLeave={() => this.filterMenuHover(false)}>
                <p className="font12">{this.state.pickedFilterDropdown} FIRST</p>
                <img src={Arrow} alt="arrow" />
                {filterDroppDown}
              </div>
            </Col>
          </Row>
          <Masonry breakpointCols={portfolioBreakpoints} className="my-masonry-grid" columnClassName="mint__gallery">
            {projectsRender}
          </Masonry>
         
        </div>
      </div>
    );
  }
}

export default Portfolio;
